<button
  [class.btn-block]="block || ((mobileService.isMobile() | async) && type !== 'icon-only')"
  [class.btn-primary]="type === 'primary'"
  [class.btn-outline]="type === 'outline'"
  [class.btn-icon-only]="type === 'icon-only'"
  [class.actions]="actionType"
  [class.edit]="actionType === 'edit'"
  [class.delete]="actionType === 'delete'"
  [class.info]="actionType === 'info'"
  [class.btn-disabled]="disabled"
  [class.disabled]="disabled"
  (click)="openLink()"
  class="btn"
  [attr.aria-label]="ariaLabel"
  >
  <ng-content></ng-content>
  @if (type !== 'icon-only') {
    <span>
      {{ text }}
    </span>
  }
  @if (icon) {
    <app-icon [type]="iconType" [icon]="icon"></app-icon>
  }
  <ng-content select="[iconText]"></ng-content>
</button>
